import { BaseMutations } from '@/store/base-mutations';
import { WidgetsSections } from '@/enums';
import { Widgets, WidgetFilters } from '../types';
import WidgetsState from './state';

export default class WidgetsMutations extends BaseMutations<WidgetsState> {
  SET_WIDGETS(items: Widgets.Widget) {
    this.state.widgets = items;
  }

  UPD_NOTIFICATION_WIDGET_TAB_MODEL(value: number) {
    this.state.notification_widget_tab_model = value;
  }

  CLEAR_TAB_MODEL() {
    this.state.notification_widget_tab_model = 0;
  }

  UPD_FILTER_KEY({ key, value, section }: { key: keyof WidgetFilters, value: unknown, section: string }) {
    this.state.filters[key] = value;
    this.state.section = section;
  }

  SET_RESPONSE_WIDGETS(item: unknown) {
    switch (this.state.section) {
      case WidgetsSections.RETRO_BONUSES:
        this.state.widgets.retro_bonuses = item as Widgets.RetroBonus;
        break;

      default:
        break;
    }
  }
}
